/**
 * Call History to Queue Model Converter
 *
 * Converts CallHistoryItem to QueueModel for use with PhoneCallSummaryModal.
 */

import type { QueueModel, CallStatus } from '@/modules/queue';
import type { CallHistoryItem } from '../../domain/types/responses';

/**
 * Convert a CallHistoryItem to a QueueModel
 *
 * The PhoneCallSummaryModal expects a QueueModel, but we have CallHistoryItem data.
 * This function maps the fields appropriately.
 */
export function convertCallHistoryToQueueModel(item: CallHistoryItem): QueueModel {
  return {
    id: item.id ?? 0,
    call_id: item.id,
    loan_id: item.loan_id,
    case_id: item.case_id,
    name: item.callee?.name ?? 'Unknown',
    role: item.callee?.role ?? '',
    relationship: '',
    tags: [],
    time_start: item.call_time_start,
    time_end: item.call_time_end,
    status: (item.call_status as CallStatus) ?? 'ended',
    order: 0,
    tier: '',
    callee: item.callee?.mobile_number ?? '',
    caller: {
      id: item.caller?.id,
      full_name: item.caller?.name,
      photo_url: item.caller?.photo_url ?? undefined,
      mobile_number: item.caller?.mobile_number,
    },
    callee_details: {
      name: item.callee?.name,
      role: item.callee?.role,
    },
    has_transcript: false,
    is_fallback: false,
    has_call_detail: true,
    is_incoming_call: item.call_type === 'incoming',
    incoming_call_id: item.incoming_call_id ?? undefined,
  };
}
